import React from "react";
import { useTranslation } from "react-i18next";
import { U2000FormStateEnumState } from "../../../../u2000Core/reducer/formReducer/U2000FormState";
import { useU2000AuthContext } from "../../../../u2000Core/context/auth/U2000UseAuthContext";
import { NS, U3148ROLES } from "../../../U3148";
import { FaRegFile } from "react-icons/fa";
import U2000ActionBtn from "../../../../u2000Core/components/buttons/U2000ActionBtn";
import U2000ResponsiveToolbar from "../../../../u2000Core/components/toolbar/U2000ResponsiveToolbar";
import type { U3148OrganizationFormExtendedHandlers } from "../../U3148OrganizationForm";

// Typage des props du composant
interface U3148OrganizationFormBtnsComponentProps {
  formStateHandlers: U3148OrganizationFormExtendedHandlers;
}

// Composant principal pour la barre d'outils du formulaire d'organisation
export const U3148OrganizationFormToolBar: React.FC<U3148OrganizationFormBtnsComponentProps> = ({ formStateHandlers }) => {
  const formState = formStateHandlers.getFormState();

  const { hasRole } = useU2000AuthContext();
  const { t } = useTranslation();

  const actions = [
    {
      key: "modify",
      label: t("btnModify", { ns: NS }),
      hasRole: hasRole(U3148ROLES.EDIT),
      handleClick: () => {
        formStateHandlers.modifyOrganization();
      },
      disabled: formState === U2000FormStateEnumState.EDIT,
      icon: FaRegFile,
      Component: U2000ActionBtn,
    },
  ];

  return <U2000ResponsiveToolbar actions={actions} />;
};
